import { Box, Text } from "@chakra-ui/react"

/**
 * Shared recharts tooltip for the report graphs. Renders one row per series
 * with its colour swatch, the series name (already the formatted, capitalised
 * legend label), and the value suffixed with the graph's unit — so the hover
 * reads with units, consistent with the unit-tagged legend. Absent values show
 * an em dash rather than a bare 0.
 *
 * Returned as a factory so the unit and date formatter can be closed over and
 * handed to recharts' `<Tooltip content={...} />`.
 */
export function unitTooltip(unit: string, formatDate: (v: string) => string) {
  const suffix = unit ? ` ${unit}` : ""
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function UnitTooltip({ active, payload, label }: any) {
    if (!active || !payload || payload.length === 0) return null
    return (
      <Box bg="white" boxShadow="card" borderRadius="md" px={3} py={2} fontSize="xs">
        <Text fontWeight="semibold" color="#2b2b2b" mb={1}>
          {formatDate(String(label))}
        </Text>
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {payload.map((entry: any) => (
          <Box key={entry.dataKey} display="flex" alignItems="center" gap={2}>
            <Box
              as="span"
              width="8px"
              height="8px"
              borderRadius="full"
              bg={entry.color}
              flexShrink={0}
            />
            <Text color="#545454">
              {entry.name}: {entry.value == null ? "—" : `${Math.round(Number(entry.value) * 10) / 10}${suffix}`}
            </Text>
          </Box>
        ))}
      </Box>
    )
  }
}
